import { useNavigate } from 'react-router';
import { IconError404 } from '@tabler/icons-react';
import { Button, EmptyState } from 'escrowbuild-ui';

import { useT } from '@/i18n';

/**
 * The platform's catch-all for an address outside the route table.
 *
 * Reached from inside the platform shell, so the navigation around it is still
 * there and the page only has to say what happened and offer the two ways out
 * that actually exist. Paths outside both shells never arrive here — the route
 * table sends those to the portal, because an investor following a stale link
 * wants their portfolio, not a dead end.
 */
export function NotFoundPage() {
  const navigate = useNavigate();
  const t = useT();

  return (
    <section className="flex flex-col">
      {/*
        `EmptyState` renders its title as a paragraph, so the page would reach a
        screen reader with no heading at all. This carries the outline entry; the
        visible title below states the same thing.
      */}
      <h1 className="sr-only">{t('notFound.heading')}</h1>

      <EmptyState
        variant="page"
        icon={<IconError404 size={32} aria-hidden="true" />}
        title={t('notFound.title')}
        description={t('notFound.description')}
        action={
          <div className="flex flex-wrap items-center justify-center gap-2">
            <Button onClick={() => navigate('/dashboard')}>{t('notFound.dashboard')}</Button>
            <Button variant="outline" onClick={() => navigate('/portal')}>
              {t('notFound.portal')}
            </Button>
          </div>
        }
      />
    </section>
  );
}
